export default __webpack_public_path__ + "static/media/blog-2.e1f51c8c.jpg";